const CheckoutActionType = {
  SET_CONNECTION_DATE_TO_PREFERRED: 'CHECKOUT_SET_CONNECTION_DATE_TO_PREFERRED',
  RESET_ALL: 'CHECKOUT_RESET_ALL',
  SET_SPEED_CHANGE_OPTION: 'CHECKOUT_SET_SPEED_CHANGE_OPTION',
  CREDIT_ASSESSMENT_SET_CURRENT_ADDRESS: 'CREDIT_ASSESSMENT_SET_CURRENT_ADDRESS',
  CREDIT_ASSESSMENT_SUBMITTING: 'CREDIT_ASSESSMENT_SUBMITTING',
  CREDIT_ASSESSMENT_STORE_APPLICATION_ID: 'CREDIT_ASSESSMENT_STORE_APPLICATION_ID',
  CREDIT_ASSESSMENT_STORE_RESULT: 'CREDIT_ASSESSMENT_STORE_RESULT',
  CREDIT_ASSESSMENT_SET_RESULT_VIEWED: 'CREDIT_ASSESSMENT_SET_RESULT_VIEWED',
  CREDIT_ASSESSMENT_SET_SUBMIT_COUNT: 'CREDIT_ASSESSMENT_SET_SUBMIT_COUNT',
  CREDIT_ASSESSMENT_ERROR: 'CREDIT_ASSESSMENT_ERROR',
  FETCH_ADDRESSES: 'CREDIT_ASSESSMENT_FETCH_ADDRESSES',
  ADDRESS_SEARCH_ERROR: 'CREDIT_ASSESSMENT_ADDRESS_SEARCH_ERROR',
  CREDIT_ASSESSMENT_RESET_CURRENT_ADDRESS: 'CREDIT_ASSESSMENT_RESET_CURRENT_ADDRESS'
};

export default CheckoutActionType;



/** WEBPACK FOOTER **
 ** ./src/common/CheckoutActionType.js
 **/